// extracted by mini-css-extract-plugin
export default {"announcements":"Z_Qv p-2","announcement":"Z_Qw card my-2","announcement--highlighted":"Z_Qx","announcement__list-item":"Z_Qy py-1","announcement__flag":"Z_Qz"};